import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(protected router: Router) { }

  ngOnInit() {
  }

  goTenants(): void {
    this.router.navigate([`/tenants`]);
  }

  goUsers(): void {
    this.router.navigate([`/users`]);
  }

  goWtp(): void {
    this.router.navigate([`/wtp`]);
  }

  goIdp(): void {
    this.router.navigate([`/idp`]);
  }

}
